import {
  Grid2 as Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Chip,
  Box,
  CardActions,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  ManageSearch as ManageSearchIcon,
  OpenInNew as OpenInNewIcon,
} from "@mui/icons-material";
import { LoadingList } from "@/organism";
import { TemplateDto } from "@/dto/TemplatesDto";

interface ListProps {
  templateList: TemplateDto[];
  onDetail?: (templateId: string) => void;
  isLoading: boolean;
}

// 📋 템플릿용 빈 상태 컴포넌트
const TemplateEmptyState = () => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    py={8}
    px={2}
    textAlign="center"
  >
    <Typography variant="h6" color="text.secondary" gutterBottom>
      템플릿이 없습니다
    </Typography>
    <Typography variant="body2" color="text.disabled">
      새로운 템플릿을 추가해보세요.
    </Typography>
  </Box>
);

export const TemplateList = ({
  templateList,
  onDetail,
  isLoading,
}: ListProps) => {
  const renderContent = () => {
    if (isLoading) {
      return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
          <LoadingList />
        </Box>
      );
    }

    if (!templateList || templateList.length === 0) {
      return <TemplateEmptyState />;
    }

    return (
      <>
        {/* 템플릿 그리드 */}
        <Grid container spacing={3}>
          {templateList.map((template) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={template.templateId}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* 썸네일 이미지 */}
                <CardMedia
                  component="img"
                  height="180"
                  image={template.thumbnailUrl || "/placeholder-image.jpg"}
                  alt={template.templateNm}
                  sx={{ objectFit: "cover" }}
                />
                <CardContent sx={{ flexGrow: 1, pt: 2 }}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <Typography variant="h6" component="div" noWrap>
                      {template.templateNm}
                    </Typography>
                    <Chip
                      label={template.dispYn === "Y" ? "노출" : "비노출"}
                      color={template.dispYn === "Y" ? "success" : "default"}
                      size="small"
                    />
                  </Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1 }}
                  >
                    노출 순서: {template.dispSn}
                  </Typography>

                  <Typography variant="body2" color="text.secondary" noWrap>
                    {template.templateDtl}
                  </Typography>
                </CardContent>

                <CardActions
                  sx={{ justifyContent: "space-between", px: 2, pb: 2 }}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<ManageSearchIcon />}
                    onClick={() => onDetail?.(template.templateId)}
                  >
                    상세보기
                  </Button>

                  <Box>
                    <Tooltip title="미리보기">
                      <IconButton
                        size="small"
                        color="primary"
                        component="a"
                        href={template.templateUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <OpenInNewIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </>
    );
  };

  return renderContent();
};
